import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
    import { alertError } from '@/utils/dialogs';

    interface Props {
        value: File;
        labelText: string;
        acceptMIME?: string;
        disabled?: boolean;
        required?: boolean;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'FileUpload',
  props: {
    value: { default: undefined },
    labelText: { default: '' },
    acceptMIME: { default: 'image/png, image/jpeg, application/pdf' },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
        // eslint-disable-next-line no-unused-vars
        (e: 'input', value: File | undefined): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as { value: File, labelText: string, acceptMIME: string, disabled: boolean, required: boolean };

    

    

    const file = computed<File>({
        get() {
            return props.value;
        },
        set(newVal: File) {
            if (checkFileSize(newVal)) {
                emit('input', newVal);
            }
        },
    });

    /**
     * Check the file size and emit error event if its size exceeds 10MB.
     *
     * @param file file
     */
    function checkFileSize(file: File): boolean {
        if (file.size > 10000000) {
            alertError(
                'Max. Dateigröße überschritten',
                'Dein hochgeladenes Bild überschreitet die maximal zulässige Dateigröße von 10 MB. Bitte verringere die Auflösung deines Scans bzw. Fotos.',
            );

            return false;
        }

        return true;
    }

return { __sfc: true,props, emit, file, checkFileSize }
}

})